<div>
  <app-bottom-nav></app-bottom-nav>
  @if (isAuthenticated()) {
    <div class="app-container" [@routeAnimations]="getRouteAnimationData()">
      <router-outlet></router-outlet>
    </div>
  }
  @if (!isAuthenticated() && !isAuthError()) {
    <div class="error-container">
      <div class="text-base opacity-4">Authenticating...</div>
    </div>
  }
  @if (isAuthError()) {
    <div class="error-container">
      <div class="text-base warn-color">Authentication Error</div>
      <button
        mat-stroked-button
        color="primary"
        size="large"
        (click)="retryAuth()"
      >
        Retry
      </button>
    </div>
  }
  <div class="text-xs version">v1.61</div>
</div>
